/**
 * Switch: internal staff chat (SR-14). Off by default, ranked testing (UI rules: anything new behind ?x=).
 *
 * The browser opts in with `?x=staff-chat` (remembered; `?x=-staff-chat` opts out). Off, nothing of the staff
 * chat renders and no staff-chat request or hub listener starts. See `src/shared/lib/practice-switches.ts`.
 */
import { isPracticeSwitchOn } from '@/shared/lib/practice-switches'

/** Whether this browser shows the staff chat (Messages page, rail item, Dashboard card). */
export function useStaffChatEnabled(): boolean {
  return isPracticeSwitchOn('staff-chat')
}
